import React from 'react'
import ReactDOM from 'react-dom'
// import './index.css';
import App from './App'
import reportWebVitals from './reportWebVitals'

// ResizeObserver エラーオーバーレイ抑制（console.error フィルタ）
const originalConsoleError = console.error
console.error = (...args) => {
  if (args[0]?.includes?.('ResizeObserver')) return
  originalConsoleError(...args)
}

// ResizeObserver エラーオーバーレイを自動で閉じる
if (process.env.NODE_ENV === 'development') {
  const observer = new MutationObserver(() => {
    const overlayIframe = document.querySelector('iframe[style*="position: fixed"]') as HTMLIFrameElement | null
    if (overlayIframe) {
      try {
        const doc = overlayIframe.contentDocument || overlayIframe.contentWindow?.document
        if (doc && doc.body.innerText.includes('ResizeObserver')) {
          overlayIframe.parentNode?.removeChild(overlayIframe)
        }
      } catch (e) {
        // cross-origin の場合はスキップ
      }
    }
  })
  observer.observe(document.body, { childList: true, subtree: true })
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
)

reportWebVitals()
